<template>
  <div class="login-wrap">
    <div class="main_box">
      <div class="left_box">
        <img class="img" src="@/assets/img/loginBg.jpg" alt="" />
      </div>
      <div class="right_box">
        <div class="con">
          <div class="title" v-if="showBox == 'login'">欢迎登录后台管理系统</div>
          <div class="title" v-if="showBox == 'forget'">找回密码</div>
          <div class="login-box" v-if="showBox == 'login'">
            <div class="phone" v-if="isShow">
              <div class="input">
                <img style="width: 20px; height: 26px; margin-left: 10px" src="@/assets/img/phone.png" alt="" />
                <input style="border: 0; outline: none" v-model="loginParam.mobile" type="text"
                  placeholder="请输入您的手机号" />
              </div>
              <div class="input">
                <img style="width: 20px; height: 24px; margin-left: 10px" src="@/assets/img/authCode.png" alt="" />
                <input style="border: 0; outline: none" type="text" v-model="loginParam.code" placeholder="请输入验证码" />
                <el-button @click="sendCode" :disabled="codeLoading" type="primary">{{ codeMsg }}</el-button>
              </div>
              <div class="footer-btn">
                <el-button @click="nextStep" type="primary">下一步</el-button>
              </div>
            </div>
            <div class="phone" v-else>
              <div class="input">
                <img style="width: 26px; height: 26px; margin-left: 10px" src="@/assets/img/user.png" alt="" />
                <input v-model="loginParam.nickname" style="border: 0; outline: none" type="text"
                  placeholder="请输入您的账号" />
              </div>
              <div class="input">
                <img style="width: 20px; height: 24px; margin-left: 15px" src="@/assets/img/lock.png" alt="" />
                <input v-model="loginParam.password" style="border: 0; outline: none" type="password"
                  placeholder="请输入密码(6-12位)" />
              </div>
              <div class="footer-btn">
                <el-button @click="backStep">上一步</el-button>
                <el-button @click="submitForm()" type="primary">登录</el-button>
              </div>
            </div>
          </div>

          <!-- 忘记密码 -->
          <div class="forget-box" v-if="showBox == 'forget'">
            <div class="phone" v-if="isShow">
              <div class="input">
                <img style="width: 20px; height: 26px; margin-left: 10px" src="@/assets/img/phone.png" alt="" />
                <input style="border: 0; outline: none" v-model="forgetParam.mobile" type="text"
                  placeholder="请输入账号绑定的手机号" />
              </div>
              <div class="input">
                <img style="width: 20px; height: 24px; margin-left: 10px" src="@/assets/img/authCode.png" alt="" />
                <input style="border: 0; outline: none" type="text" v-model="forgetParam.code" placeholder="请输入验证码" />
                <el-button @click="sendCode" :disabled="codeLoading" type="primary">{{ codeMsg }}</el-button>
              </div>
              <div class="footer-btn">
                <el-button @click="nextStep" type="primary">下一步</el-button>
              </div>
            </div>
            <div class="phone" v-else>
              <div class="input">
                <img style="width: 20px; height: 24px; margin-left: 15px" src="@/assets/img/lock.png" alt="" />
                <input v-model="forgetParam.password" style="border: 0; outline: none" type="password"
                  placeholder="请输入新密码" @blur="checkPwd" />
                <div class="tips" v-if="showTip">新密码必须包含大小写字母及数字且不低于6位</div>
              </div>
              <div class="input">
                <img style="width: 20px; height: 24px; margin-left: 15px" src="@/assets/img/lock.png" alt="" />
                <input v-model="confirmPwd" style="border: 0; outline: none" type="password" placeholder="请再次输入密码" />
              </div>
              <div class="footer-btn">
                <el-button @click="backStep">上一步</el-button>
                <el-button @click="submitEdit()" type="primary">确认修改</el-button>
              </div>
            </div>
          </div>

          <div class="action">
            <div class="forget-title" @click="forgetPwd" v-if="showBox == 'login'">忘记密码?</div>
            <div class="forget-title" @click="backLogin" v-if="showBox == 'forget'">返回登录</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dictionary from '@/utils/dictionary';
export default {
  data: function () {
    return {
      // 登录参数
      loginParam: {
        nickname: '',
        password: '',
        mobile: '',
        code: ''
      },

      // 忘记密码参数
      forgetParam: {
        password: '',
        mobile: '',
        code: ''
      },

      confirmPwd: '',

      codeMsg: '发送验证码',
      timeCount: 60,
      codeLoading: false, // 验证码按钮

      isShow: true, // 登录切换

      showBox: 'login', // 登录or忘记密码

      showTip: false, // 密码提示,
      timer: null
    };
  },
  created() { 

  },
  methods: {
    submitForm() {
      if (!this.loginParam.nickname) {
        this.$message.error('用户名不能为空！！！');
        return;
      } else if (!this.loginParam.password) {
        this.$message.error('密码不能为空！！！');
        return;
      } else {
        let that = this;
        let url = '/api/ucenter.passport/signIn';
        let query = this.loginParam;
        that.$post(url, query).then(function (response) {
          if (response.code == '200') {
            let result = response.data;
            that.$message.success(response.msg);
            localStorage.setItem('token', result.token);
            let user = JSON.stringify(result.user);
            localStorage.setItem('user', user);
            let permission = JSON.parse(result.permission);
            localStorage.setItem('permission', permission);
            // 加载系统需要的picker
            dictionary.initPicker();
            that.$router.push({
              path: '/dashboard'
            });
          } else {
            that.$message.error(response.msg);
            return false;
          }
        });
      }
    },

    // 发送验证码
    sendCode() {
      let that = this;
      let loginParam = that.loginParam;
      let forgetParam = that.forgetParam;
      let checkMobile = /^1[3-9][0-9]\d{8}$/;
      if (that.showBox == 'login') {
        if (loginParam.mobile == '') {
          that.$message.error('手机号不能为空');
        } else if (!checkMobile.test(loginParam.mobile)) {
          that.$message.error('手机号格式不正确');
        } else {
          that.codeMsg = that.timeCount + 's后重新发送';
          that.codeLoading = true;
          that.timer = window.setInterval(() => {
            that.timeCount--;
            that.codeMsg = that.timeCount + 's后重新发送';
            if (that.timeCount == 0) {
              that.codeLoading = false;
              window.clearInterval(that.timer);
              that.codeMsg = '重新发送';
              that.timeCount = 60;
            }
          }, 1000);
          let url = '/api/ucenter.passport/loginCode';
          let query = { mobile: loginParam.mobile };
          that.$post(url, query).then(function (response) {
            if (response.code == 200) {
              that.$message.success('验证码发送成功，请注意查看信息');
              //  that.getCode = response.data.code;
            } else {
              that.$message.error(response.msg);
              that.codeLoading = false;
              window.clearInterval(that.timer);
              that.codeMsg = '重新发送';
              that.timeCount = 60;
              return false;
            }
          });
        }
      } else {
        if (forgetParam.mobile == '') {
          that.$message.error('手机号不能为空');
        } else if (!checkMobile.test(forgetParam.mobile)) {
          that.$message.error('手机号格式不正确');
        } else {
          that.codeMsg = that.timeCount + 's后重新发送';
          that.codeLoading = true;
          that.timer = window.setInterval(() => {
            that.timeCount--;
            that.codeMsg = that.timeCount + 's后重新发送';
            if (that.timeCount == 0) {
              that.codeLoading = false;
              window.clearInterval(that.timer);
              that.codeMsg = '重新发送';
              that.timeCount = 60;
            }
          }, 1000);
          let url = '/api/ucenter.passport/loginCode';
          let query = { mobile: forgetParam.mobile };
          that.$post(url, query).then(function (response) {
            if (response.code == 200) {
              that.$message.success('验证码发送成功，请注意查看信息');
              // that.getCode = response.data.code;
            } else {
              that.$message.error(response.msg);
              that.codeLoading = false;
              window.clearInterval(that.timer);
              that.codeMsg = '重新发送';
              that.timeCount = 60;
              return false;
            }
          });
        }
      }
    },
    // 下一步
    nextStep() {
      let _this = this;
      let loginParam = this.loginParam;
      let forgetParam = this.forgetParam;
      let checkMobile = /^1[3-9][0-9]\d{8}$/;
      if (this.showBox == 'login') {
        if (loginParam.mobile == '') {
          _this.$message({
            type: 'error',
            message: '手机号不能为空'
          });
          return false;
        }
        if (!checkMobile.test(loginParam.mobile)) {
          _this.$message({
            type: 'error',
            message: '手机号格式不正确'
          });
          return false;
        }
        if (loginParam.code == '') {
          _this.$message({
            type: 'error',
            message: '验证码不能为空'
          });
          return false;
        }
        let url = '/api/ucenter.passport/checkCode';
        let params = {
          mobile: _this.loginParam.mobile,
          code: _this.loginParam.code
        };
        this.$post(url, params).then(res => {
          if (res.code == 200) {
            _this.$message.success(res.msg);
            _this.showBox = 'login';
            _this.isShow = false;
          } else {
            _this.$message.error(res.msg);
            _this.showBox = 'login';
            _this.isShow = true;
            return false;
          }
        });
      }
      if (_this.showBox == 'forget') {
        if (forgetParam.mobile == '') {
          _this.$message({
            type: 'error',
            message: '手机号不能为空'
          });
          return false;
        }
        if (!checkMobile.test(forgetParam.mobile)) {
          _this.$message({
            type: 'error',
            message: '手机号格式不正确'
          });
          return false;
        }
        if (forgetParam.code == '') {
          _this.$message({
            type: 'error',
            message: '验证码不能为空'
          });
          return false;
        }
        let url = '/api/ucenter.passport/checkCode';
        let params = {
          mobile: _this.forgetParam.mobile,
          code: _this.forgetParam.code
        };
        this.$post(url, params).then(res => {
          if (res.code == 200) {
            _this.$message.success(res.msg);
            _this.showBox = 'forget';
            _this.isShow = false;
          } else {
            _this.$message.error(res.msg);
            _this.showBox = 'forget';
            _this.isShow = true;
            return false;
          }
        });
      }
    },
    // 上一步
    backStep() {
      this.isShow = true;
    },

    // 忘记密码
    forgetPwd() {
      this.showBox = 'forget';
      this.isShow = true;
      window.clearInterval(this.timer);
      this.timer = null;
      this.codeMsg = '发送验证码';
      this.timeCount = 60;
      this.codeLoading = false;
    },
    // 返回登录
    backLogin() {
      this.showBox = 'login';
      window.clearInterval(this.timer);
      this.timer = null;
      this.codeMsg = '发送验证码';
      this.timeCount = 60;
      this.codeLoading = false;
    },
    // 检测密码
    checkPwd() {
      let that = this;
      let param = that.forgetParam;
      let checkPassword = new RegExp('(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[a-zA-Z0-9]{6,12}');
      if (!checkPassword.test(param.password)) {
        that.showTip = true;
      } else {
        that.showTip = false;
      }
    },
    // 确认修改
    submitEdit() {
      let that = this;
      let param = that.forgetParam;
      let url = '/api/ucenter.passport/forget';
      if (that.confirmPwd != param.password) {
        that.$message.error('两次密码输入不一致');
        return false;
      }
      that.$post(url, param).then(function (response) {
        if (response.code == 200) {
          that.$message.success(response.msg);
          that.showBox = 'login';
          that.isShow = true;
          window.clearInterval(that.timer);
          that.codeMsg = '发送验证码';
          that.timeCount = 60;
          that.codeLoading = false;
          that.loginParam.mobile ='';
          that.loginParam.code =''
        } else {
          that.$message.error(response.msg);
        }
      });
    }
  }
};
</script>

<style scoped>
.login-wrap {
    position: relative;
    width: 100%;
    height: 100%;
}
.main_box {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
}
.main_box .left_box {
    width: auto;
    height: 800px;
}
.main_box .left_box .img {
    width: auto;
    height: 100%;
}
.main_box .right_box {
    width: 780px;
    height: 800px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 5px -5px 10px #f0f0f0, 5px 5px 10px #f0f0f0;
}
.main_box .right_box .con {
    width: 100%;
    height: auto;
}
.main_box .right_box .con .title {
    width: 100%;
    height: 50px;
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #2074ff;
    text-align: center;
}
.main_box .right_box .con .phone {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.main_box .right_box .con .phone .input {
    width: 480px;
    height: 50px;
    border-bottom: 2px solid #ededed;
    margin-top: 30px;
    display: flex;
    align-items: center;
}
.main_box .right_box .con .phone .input input {
    width: 320px;
    margin-left: 20px;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    line-height: 33px;
}
input::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #acacac;
}

.main_box .right_box .con .phone .change {
    width: 480px;
    display: flex;
    justify-content: flex-end;
    padding: 10px 5px;
    box-sizing: border-box;
}

.footer-btn {
    padding-top: 20px;
    display: flex;
    width: 60%;
    justify-content: space-between;
    align-items: center;
}

.tips {
    font-size: 12px;
    color: red;
}

.action {
    margin: 0 auto;
    width: 60%;
    padding-top: 20px;
    color: #acacac;
    font-size: 12px;
}

.forget-title {
    width: 6rem;
    cursor: pointer;
    text-decoration: underline;
}

.forget-title:hover {
    color: #409eff;
}
</style>
